<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('journalReglements.titre')}}</h1>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #bar-left>
      <div class="column">
        <search-bar
          @recherche="recherche">
        </search-bar>
      </div>
    </template>
    <template #bar-right>
      <div class="columns">
        <div class="column">
          <exportExcelButton
            :perm="JOURNAL_REGLEMENTS.exporter"
            :query="exportExcelQuery"/>
        </div>
        <div class="column">
          <parametrage-table
            :referenceTable="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
    </template>
    <template #content>
      <v-server-table
        :columns="columns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="referenceTable"
        v-if="startArrayRendering"
      >
        <div slot="dateMouvement" slot-scope="props">
          <router-link-blank :to="{ name: 'c.bodac.remises_bancaires',
            params: {id: props.row.remiseBancaireId}}"
            :message="func.formatDate(props.row.dateMouvement)">
          </router-link-blank>
        </div>
        <div slot="client" slot-scope="props">
          <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
            params: {id: props.row.tiersId}}"
            :message="props.row.tiers.nomCommercial">
          </router-link-blank>
        </div>
        <div slot="commercial" slot-scope="props">
          <div>
            {{getCommercial(props.row)}}
          </div>
        </div>
        <div slot="montantDuMouvement" slot-scope="props">
          <div
            v-if="props.row.montantDuMouvement !== undefined"
            class="is-pulled-right">
            {{func.formatDevise(props.row.montantDuMouvement)}}
          </div>
        </div>
        <div slot="montantTtc" slot-scope="props">
          <div
            v-if="props.row.montantTtc !== undefined"
            class="is-pulled-right">
            {{func.formatDevise(props.row.montantTtc)}}
          </div>
        </div>
        <div slot="montantLettre" slot-scope="props">
          <div
            v-if="props.row.montantLettre !== undefined"
            class="is-pulled-right">
            {{func.formatDevise(props.row.montantLettre)}}
          </div>
        </div>
        <div slot="codeFactureOuContrat" slot-scope="props">
          <div v-for="(codeFactureOuContrat, cIndex) in props.row.codeFactureOuContrat"
            :key="`codeFactureOuContrat-${codeFactureOuContrat.id}-${cIndex}`">
              <router-link-blank
                :to="{
                  name: 'c.bodac.factures',
                  params: {id: codeFactureOuContrat.id}}"
                :message="codeFactureOuContrat.code">
              </router-link-blank>
          </div>
        </div>
        <template slot='appendBody'>
          <table-footer-totaux
              ref="tableTotaux"
              :columns="columns"
              :target="targetTotal"
              :items="journalReglements">
          </table-footer-totaux>
        </template>
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[referenceTable].setLimit($event)"
          />
        </template>
      </v-server-table>
    </template>
  </liste-template>
</template>

<script>

import { JOURNAL_REGLEMENTS } from '@/configuration/permissionsBodacConf';
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import listeTemplate from '@/components/general/template/listeTemplate';
import Breadcrumb from '@/components/general/breadcrumb';
import TableItemsInView from '@/components/general/TableItemsInView';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import searchBar from '@/components/bodac/journalReglements/searchBar';
import {
  SORT_ICON,
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  TEXTS,
} from '@/configuration/clientTableConf';
import { REFERENCE_TABLE_JOURNAL_REGLEMENTS } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import messageErreur from '@/services/general/messageErreur';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { formatDevise } from '@/services/general/filters/formatDevise';
import formatDateIso from '@/services/general/formatIsoDate';
import {
  ECRANS_JOURNAL_REGLEMENTS_TYPE_EXPORT_EXCEL,
  ECRANS_JOURNAL_MOUVEMENTS_EXPORT_EXCEL,
} from '@/configuration/mouvementClient/mouvementClientConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const JournalReglements = createNamespacedHelpers('journalReglements');
const Societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    searchBar,
    listeTemplate,
    Breadcrumb,
    parametrageTable,
    routerLinkBlank,
    tableFooterTotaux,
    TableItemsInView,
    exportExcelButton,
  },
  data() {
    return {
      users: [],
      referenceTable: REFERENCE_TABLE_JOURNAL_REGLEMENTS,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      func: {
        formatDate,
        formatDevise,
        formatDateIso,
      },
      openExportJReglements: false,
      JOURNAL_REGLEMENTS,
    };
  },
  computed: {
    ...JournalReglements.mapGetters({
      journalReglements: 'items',
      criteresRecherche: 'critereRechercheJournalReglements',
      total: 'total',
      lastPayload: 'lastPayload',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    exportExcelQuery() {
      return {
        typeDonnee: ECRANS_JOURNAL_MOUVEMENTS_EXPORT_EXCEL,
        typeExport: ECRANS_JOURNAL_REGLEMENTS_TYPE_EXPORT_EXCEL,
        filtres: {
          ...this.lastPayload,
          ...(this.lastPayload.orderBy
            && { sorting: `${this.lastPayload.orderBy.split(' ')[0]} ${this.lastPayload.ascending ? ' ASC' : ' DESC'}` }),
        },
      };
    },
    breadcrumb() {
      return [
        { title: this.$t('journalReglements.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('journalReglements.titre'), route: { name: 'l.bodac.journal_reglements' }, isActive: true },
      ];
    },
    columns() {
      return [
        'dateMouvement',
        'remiseBancaire.domiciliationBancaire.libelle',
        'ligneRemiseBancairePseudoEntity.emetteur',
        'ligneRemiseBancairePseudoEntity.referenceReglement',
        'client',
        'commercial',
        'tiers.compteComptable',
        'remiseBancaire.modeReglement.libelle',
        'montantDuMouvement',
        'codeFactureOuContrat',
        'montantTtc',
        'montantLettre',
      ];
    },
    targetTotal() {
      return ['montantTtc', 'montantDuMouvement', 'montantLettre'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateMouvement: this.$t('journalReglements.table.colonnes.dateReglement'),
          'remiseBancaire.domiciliationBancaire.libelle': this.$t('journalReglements.table.colonnes.domiciliationBancaire'),
          'ligneRemiseBancairePseudoEntity.emetteur': this.$t('journalReglements.table.colonnes.nomTire'),
          'ligneRemiseBancairePseudoEntity.referenceReglement': this.$t('journalReglements.table.colonnes.referenceTire'),
          client: this.$t('journalReglements.table.colonnes.client'),
          commercial: this.$t('journalReglements.table.colonnes.commercial'),
          'tiers.compteComptable': this.$t('journalReglements.table.colonnes.compteComptable'),
          'remiseBancaire.modeReglement.libelle': this.$t('journalReglements.table.colonnes.modeReglement'),
          montantDuMouvement: this.$t('journalReglements.table.colonnes.montantRegle'),
          codeFactureOuContrat: this.$t('journalReglements.table.colonnes.codeFactureOuContrat'),
          montantTtc: this.$t('journalReglements.table.colonnes.montantTtcAPayer'),
          montantLettre: this.$t('journalReglements.table.colonnes.montantLettre'),
        },
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        columnsClasses: {
          listeIntervenants: 'ellipsis colonneListeIntervenants',
        },
        filterable: false,
        sortable: this.columns.filter(c => c !== 'codeFactureOuContrat' && c !== 'commercial' && c !== 'montantTtc' && c !== 'montantLettre'),
        requestFunction: ((data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.tiersIds = data.query.tiersIds?.map(t => t.id);
          if (data.query.borneCredit !== null
            && data.query.borneCredit.borneMin === null
            && data.query.borneCredit.borneMax === null) {
            delete (data.query.borneCredit);
          }
          if (data.query.dates && data.query.dates.dateDebut) {
            data.query.dates.dateDebut = this.func.formatDateIso(data.query.dates.dateDebut);
          }
          if (data.query.dates && data.query.dates.dateFin) {
            data.query.dates.dateFin = this.func.formatDateIso(data.query.dates.dateFin);
          }
          if (data.orderBy?.includes('montantDuMouvement')) {
            data.orderBy = data.orderBy.replace('montantDuMouvement', 'montantDuReglement');
          }
          return this.actionsLoadMouvement(data)
            .catch(() => {
              this.finLoading();
              messageErreur(this.$i18n);
            });
        }),
        responseAdapter: (() => {
          return {
            data: this.journalReglements,
            count: this.total,
          };
        }),
      };
    },
  },
  methods: {
    ...JournalReglements.mapActions({
      actionsLoadMouvement: 'loadJournalReglements',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...JournalReglements.mapMutations({
      setCritere: 'SET_CRITERE_JOURNAL_REGLEMENTS',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getCommercial(row) {
      if (!row.codeFactureOuContrat[0]?.commercialId) {
        return '';
      }
      const utilisateur = this.users.find((user) => {
        return user.id === row.codeFactureOuContrat[0]?.commercialId;
      });
      return utilisateur.decorator.nomPrenom;
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
  },
  async mounted() {
    try {
      await this.loadParametreUtilisateur();
      this.users = this.parametre(PARAMETRES_KEYS.utilisateur);
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    }
    const critere = cloneDeep(this.criteresRecherche);
    await updateCritereWithParametreInterne(critere);
    this.setCritere(critere);
    this.setInformationPage(this.$t('pageGescom.journalReglements.liste'));
  },
};
</script>
